const AnswerMeChildSafetyStandards = () => {
  return (
    <div id="child-safety-standards">
      <p>
        <strong>
          Child Safety Standards — Answer Me: Everyday Q&A (CSAE Policy)
        </strong>
      </p>
      <p>
        This section describes the standards of My Fortuna LLC against child
        sexual abuse and exploitation (CSAE) for the Answer Me: Everyday Q&A
        app (“Answer Me”). My Fortuna LLC has zero tolerance for child
        sexual abuse and exploitation of any kind. Content or behavior that
        sexualizes, exploits, grooms, endangers, or otherwise harms children is
        strictly prohibited anywhere in Answer Me, including in questions,
        question descriptions, images, and answers. This includes, without
        limitation, child sexual abuse material (CSAM), the solicitation of
        minors, sextortion, the trafficking of minors, and any attempt to use
        the app to contact, groom, or harm a minor.
      </p>
      <p>
        <strong>In-app reporting.</strong> Answer Me provides an in-app
        mechanism for users to report concerns, including child safety
        concerns, without leaving the app: while answering, any question can be
        reported through the options menu on the answering screen. Reports may
        also be sent to us directly at support@myfortuna.app. Reports involving
        child safety are prioritized.
      </p>
      <p>
        <strong>Enforcement.</strong> When we become aware of content or
        behavior that violates these standards, we take appropriate action,
        including removing the content, restricting or terminating the
        responsible user’s access to the service, and preserving and
        reporting CSAM and related activity to the National Center for Missing
        & Exploited Children (NCMEC) and/or the relevant regional and
        national law enforcement authorities, as required by applicable law.
      </p>
      <p>
        <strong>Legal compliance.</strong> Answer Me: Everyday Q&A and
        My Fortuna LLC comply with applicable child safety laws in the regions
        where the app is offered, and cooperate with law enforcement requests
        relating to child safety.
      </p>
      <p>
        <strong>Child safety point of contact.</strong> Questions about these
        standards, and child safety reports or inquiries from users, regulators,
        or law enforcement, can be directed to My Fortuna LLC at
        support@myfortuna.app.
      </p>
    </div>
  );
};

export default AnswerMeChildSafetyStandards;
